import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted, watchEffect } from 'vue';
import type Swiper from 'swiper';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { linkify } from '@/js/lib/helper/linkify';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoDialog',
  props: {
    list: { default: () => [] },
    currentIndex: { default: 0 },
    isShowModal: { type: Boolean },
    injectStyles: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { list: {
      path: string;
      width: number;
      height: number;
      comment: string;
    }[], currentIndex: number, isShowModal?: boolean, injectStyles: string[] };


const wrapperRef = ref();
const isMounted = ref(false);
const swiper = ref<Swiper>();
const newList = computed(() => props.list);
const isShow = computed(() => props.isShowModal);
const current = computed(() => (swiper.value?.realIndex as number) || 0);
const comment = computed(() => newList.value[current.value].comment);

onMounted(() => {
  isMounted.value = true;
});
onUnmounted(() => {
  swiper.value?.destroy();
});

watchEffect(() => {
  if (!swiper.value && isMounted.value && isShow.value && newList.value.length > 1) {
    Object.assign(wrapperRef.value, {
      navigation: true,
      zoom: true,
      initialSlide: props.currentIndex,
      injectStyles: props.injectStyles,
    });

    wrapperRef.value.addEventListener('swiperprogress', (e) => {
      [swiper.value] = e.detail;
    });
    wrapperRef.value.initialize();
  }
});

return { __sfc: true,props, wrapperRef, isMounted, swiper, newList, isShow, current, comment, dynamicImageUrl, linkify }
}

})